var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"size":"mini"},on:{"change":_vm.change},model:{value:(_vm.isFixedRate),callback:function ($$v) {_vm.isFixedRate=$$v},expression:"isFixedRate"}})}
var staticRenderFns = []

export { render, staticRenderFns }